import type { PostCommentThreadsQuery } from '../../graphql/generated/graphqlTypes';
import updateApolloList from '../../utils/graphql/updateApolloList';

const updateCommentReactionList = <
  Data extends { [key in NewItemKey]?: NewItem | null },
  NewItemKey extends string,
  NewItem extends Item,
  Item extends { id?: string | null } | string,
>(
  { threadId, commentId }: { threadId: string; commentId: string },
  prev: PostCommentThreadsQuery,
  data: Data,
  itemKey: string,
  add = true,
) => ({
  ...prev,
  post: prev.post && {
    ...prev.post,
    threads: prev.post.threads?.map((thread) =>
      thread.id !== threadId
        ? thread
        : {
            ...thread,
            comments: thread.comments?.map((comment) =>
              comment.id !== commentId
                ? comment
                : updateApolloList(comment, data, 'reactions', itemKey, add),
            ),
          },
    ),
  },
});

export default updateCommentReactionList;
